import { useAuth } from '@/hooks/useAuth';
import { useOfflineDegradedMode } from '@/hooks/useOfflineDegradedMode';
import { saveStoredReferentials } from '@/store/referentials/referentials.storage';
import { useReferentialsFindAll } from '@api/WhisApi/generated';
import { useEffect } from 'react';

export const ReferentialsPrefetcher = (): null => {
  const { isAuthenticated } = useAuth();
  const { isOfflineDegradedMode } = useOfflineDegradedMode();

  const referentialsQuery = useReferentialsFindAll({
    query: {
      enabled: isAuthenticated && !isOfflineDegradedMode,
      staleTime: 5 * 60 * 1000,
    },
  });

  useEffect(() => {
    if (!referentialsQuery.data) {
      return;
    }

    void saveStoredReferentials(referentialsQuery.data);
  }, [referentialsQuery.data]);

  return null;
};
